import { useLocalStorage } from "../../../shared/hooks/useLocalStorage";
import { KEY_REMEMBER_DEFAULT_SELECTED_ORGANIZATION_ACCOUNT_EMAIL } from "../constants/storage";

export const useStoredDefaultSelectedAccount = () => {
  return useLocalStorage(
    KEY_REMEMBER_DEFAULT_SELECTED_ORGANIZATION_ACCOUNT_EMAIL,
    ""
  );
};